import { Box } from "@mui/material";
import backgroundLogin from "../../../assets/logosmall.png";

export default function BackgroundLoginSvg({ children }) {
  const backgroundColor = {
    backgroundColor: "#f1f6ff",
    backgroundImage: `url(${backgroundLogin})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "120px",
    backgroundPosition: "70% 90%",

  };
  return <Box sx={backgroundColor} >{children}</Box>;
}
